module.exports = __webpack_public_path__ + "static/img/product5-3.4f92571.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/product5-3.jpg
// module id = 2p3K
// module chunks = 0